const API_PREFIX = '/api'

//  /api não deve ser retornado caso nao tenha a url pois será interpretado como url interna
export const SERVER_BACKEND_URL = process.env.NEXT_BACKEND_URL ?? ''
export const SERVER_API_URL = SERVER_BACKEND_URL ? SERVER_BACKEND_URL + API_PREFIX : ''
export const CLIENT_BACKEND_URL  = process.env.NEXT_PUBLIC_BACKEND_URL ?? ''
export const CLIENT_API_URL = CLIENT_BACKEND_URL ? CLIENT_BACKEND_URL + API_PREFIX : ''
export const FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL ?? '';